import { Table, TableCell, TableRow } from '@amzn/meridian';
import type { TableRowComponents } from '@amzn/meridian/table/table';
import type { ReactNode } from 'react';
import { subTableCSS as css } from '../styles/styles';

export const SummaryTableWrapper = ({ children, rowComponents }: { children: ReactNode; rowComponents?: TableRowComponents[] }) => (
  <Table className={css.subTable} rowComponents={rowComponents} showStripes spacing="medium">
    <TableRow aria-hidden>
      <TableCell aria-hidden>
        <span aria-hidden />
      </TableCell>
    </TableRow>
    {children}
    <TableRow>
      <TableRow aria-hidden>
        <TableCell aria-hidden>
          <span aria-hidden />
        </TableCell>
      </TableRow>
    </TableRow>
  </Table>
);
